interface SkeletonProps {
  className?: string;
}

function Shimmer({ className = '' }: SkeletonProps) {
  return (
    <div className={`animate-pulse rounded-lg bg-slate-200/70 ${className}`} />
  );
}

export function BoardSkeleton() {
  return (
    <div className="flex h-full flex-col">
      <div className="shrink-0 px-3 pt-3 sm:px-6 sm:pt-4">
        <div className="rounded-2xl border border-white/60 bg-white/80 px-4 py-3 sm:rounded-[28px] sm:px-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Shimmer className="h-6 w-40" />
              <Shimmer className="h-5 w-16 rounded-full" />
              <Shimmer className="h-5 w-16 rounded-full" />
            </div>
            <Shimmer className="h-5 w-5" />
          </div>
        </div>
      </div>
      <div className="mt-3 flex flex-1 gap-4 px-3 sm:mt-4 sm:gap-6 sm:px-6">
        {[0, 1, 2, 3].map((col) => (
          <div key={col} className="w-[85vw] shrink-0 sm:w-80">
            <Shimmer className="mb-3 h-14 rounded-t-xl" />
            <div className="space-y-3 rounded-xl bg-gray-50/50 p-3">
              {[0, 1, 2].map((card) => (
                <div key={card} className="rounded-2xl border border-slate-200/60 bg-white/80 p-4">
                  <Shimmer className="mb-3 h-3 w-24" />
                  <Shimmer className="mb-2 h-5 w-3/4" />
                  <Shimmer className="mb-4 h-3 w-full" />
                  <Shimmer className="h-3 w-2/3" />
                  <div className="mt-3 flex gap-2">
                    <Shimmer className="h-5 w-14 rounded-full" />
                    <Shimmer className="h-5 w-14 rounded-full" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function CardModalSkeleton() {
  return (
    <div className="p-4 sm:p-6 space-y-4">
      <Shimmer className="h-8 w-3/4" />
      <Shimmer className="h-4 w-1/2" />
      <div className="space-y-3 pt-4">
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-5/6" />
        <Shimmer className="h-4 w-3/4" />
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-2/3" />
      </div>
    </div>
  );
}
